import { required, number } from '@epi-helpers/formHelpers/validators';

/** Admin topup: amount/days are required but not capped by yearly or working-day limits. */
export const adminAmountValidators = [required];

export const adminWorkingDaysValidators = [required, number];
